<template>
    <div class="clearfix" id="case-details-box">
        <nav-header></nav-header>
         <div class="row mx-0">
            <div class="case-swiper-box">
                <!-- '/express_api'+ -->
                <img v-if="detailsData.cover!=''" :src="(typeof detailsData.cover != 'undefined' || detailsData.cover === null)? detailsData.cover:''" alt="" />
            </div>
        </div>
        <div class="row px-0 case-icon-container">
            <div class="case-details-title">
                {{detailsData.title}}
            </div>
            <div class="case-details-title">
                <h3>项目类别</h3>
                <div>
                    {{detailsData.creation}}
                </div>
            </div>
            <div class="case-details-title">
                <h3>项目内容</h3>
                <div>
                    {{detailsData.svccontent}}
                </div>
            </div>
            <div class="case-details-title">
                <h3>项目背景</h3>
                <div>
                    {{detailsData.project}}
                </div>
            </div>
        </div>
        <div class="case-content-container case-content-common" v-html="detailsData.content">
        </div>
        <div class="row px-0 case-content-common">
            <div class="case-case-title">
                <p>更多精选案例</p>
                <p>EXCELLENT CASES</p>
            </div>
            <div class="case-case-box mx-0 row" v-if="pageData.length>0">
                <div class="col-4 col-lg-4 card border-0 px-0 py-0" v-for="(value,index) in pageData" :key="index" @click="caseDetails(value.id)">
                    <img :src="typeof value.cover != 'undefined'? '/express_api'+value.cover:''"/>
                    <div class="card-body pb-0">
                        <h4 class="mb-0">{{value.title}}</h4>
                        <p>项目内容：{{value.svccontent}}</p>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
// @ is an alias to /src
import NavHeader from "@/components/navHeader.vue";
import Footer from "@/components/footer.vue";
import { selectCases,selectCasesById } from '@/api/cases';

export default {
    name: "CaseDetails",
    components: {
        NavHeader,
        Footer
    },
    data() {
        return {
            //案例id
            id: "",
            detailsData: {},
            pageData: []
        };
    },
    created() {
        this.paramsUrl();
    },
    methods: {
        /**
         * @desc 新闻id
         */
        pageClick(id) {
            this.$router.push({
                path: "/caseDetails",
                query: {
                    id
                }
            })
        },
        /**
         * @desc 检测页面参数是否完整
         */
        paramsUrl() {
            let query = this.$route.query;

            if (typeof query.id !== 'undefined') {
                this.id = query.id;

                this.selectById();
                this.selectMoreData();
            } else {
                this.$message({
                    message: 'id不存在',
                    type: 'warning'
                })
                this.$router.push({
                    path: "/case"
                })
            }
        },
        /**
         * @desc 通过id获取详细数据
         */
        selectById() {
            let params = {
                id: this.id
            }
            selectCasesById(params).then(res => {
                let str = res.data[0].content.match(/<img[^>]*>/i);
                
                if(str === null) {
                    str = '';
                } else {
                    let arrimg = [];
                    str[0].replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, capture) {
                        arrimg.push(capture);
                    });
                    if (arrimg !=null && arrimg.length >0) {
                        str = arrimg[0];
                    }else {
                        str = '';
                    }
                }
                res.data[0].cover = str;
                res.data[0].content = res.data[0].content.replace(/<img[^>]*>/i,'');
                this.detailsData =res.data[0];
            })
        },
        /**
         * @desc 通过id查询上下条数据
         */
        selectMoreData() {
            let params = {
                // id: this.id
                page: 1,
                size: 3
            }
            selectCases(params).then(res => {
                if(res.code == 200) {
                    this.pageData = res.data;
                }
            })
        },
        /**
         * @desc 案例查询详情
         */
        caseDetails(id) {
            this.$router.push({
                path: '/caseDetails',
                query: {
                    id
                }
            })
        },
    },
    mounted() {
    }
};
</script>
<style lang="scss" scoped>
#case-details-box {
    margin-top: 80px;

    .case-swiper-box {
        // height: 890px;
        width: 100%;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .case-icon-container {
        width: 1200px;
        margin: 80px auto;

        .case-details-title {
            color: #333333;
            font-size: 24px;
            width: 100%;
            text-align: left;
            margin-bottom: 30px;

            h3 {
                font-weight: bold;
                font-size: 16px;
            }

            div {
                font-size: 16px;
            }
            
        }
    }

    .case-content-common {
        // width: 1770px;
        margin: 0 75px;
        text-align: left;

        .case-case-title {
            width: 100%;
            margin: 95px auto 55px;
            height: 50px;
            text-align: center;

            p {
                margin: 0;
                font-size: 24px;
                color: #333333;

                &:last-child {
                    font-size: 14px;
                    color: #999999;
                }
            }
        }

        .case-case-box {
            width: 100%;
            margin-bottom: 220px;
            
            .card {
                position: relative;
                overflow: hidden;
                cursor: pointer;

                img {
                    height: 390px;
                    transition: all 0.2s linear;
                }
                .card-body {
                    // display: none;
                    transition: all 0.2s linear;
                    position: absolute;
                    bottom: 0;
                    background: rgba(0,0,0,.7);
                    width: 100%;
                    color: #fff;
                    line-height: 24px;
                    box-sizing: border-box;
                    padding-left: 30px;
                    text-align: left;
                    transition: all 0.2s linear;
                    transform: rotateY(90deg);

                    h4 {
                        font-size: 20px;
                    }
                    p {
                        font-size: 14px;
                    }
                }

                &:hover {
                    img {
                        transform: scale(1.2);
                    }
                    .card-body {
                        // display: block;
                        transform: rotate(0);
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 1260px){
    #case-details-box {
        .case-icon-container {
            width: auto;
            margin: 80px 20px;
        }
    }
}
</style>

<style lang="scss">
#case-details-box {
    .case-content-container {
        text-align: center;

        img {
            max-width: 100%;
            margin: 0 auto 15px;
            display: block;
        }
    }
}
</style>
